import AdviceCard from "./components/AdviceCard/AdviceCard.jsx";

import "./media.css";

function App() {
  return (
    <div className="App">
      <AdviceCard />
    </div>
  );
}

export default App;
